/**
 * variant-media-filter.js  (v9 - patch window.scrollTo, le vrai coupable)
 *
 * Dawn utilise window.scrollTo({behavior:'smooth'}) dans setActiveMedia
 * (media-gallery.js ligne 63), ce qui scrolle la page à chaque variant change
 * même quand seule la taille change.
 *
 * Stratégie :
 *  1) Patch focus() → preventScroll dans <variant-selects>
 *  2) Patch window.scrollTo() → no-op pendant variant change, sauf pour
 *     mes propres scrolls (drapeau allowOurScroll).
 *  3) Cache la couleur filtrée : taille seulement = 0 traitement, 0 scroll.
 *  4) Couleur change → 1 seul scrollTo(0,0) à la fin.
 */
(function () {
  'use strict';

  // === DRAPEAUX D'ÉTAT ===
  var inVariantChange = false;
  var allowOurScroll = false;
  var clearVariantChangeTimer = null;

  function markVariantChange() {
    inVariantChange = true;
    clearTimeout(clearVariantChangeTimer);
    clearVariantChangeTimer = setTimeout(function () {
      inVariantChange = false;
    }, 2000);
  }

  // === PATCH 1 : focus() preventScroll dans <variant-selects> ===
  (function () {
    var origFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (opts) {
      try {
        if (this.closest && this.closest('variant-selects')) {
          opts = Object.assign({ preventScroll: true }, opts || {});
        }
      } catch (e) { /* ignore */ }
      return origFocus.call(this, opts);
    };
  })();

  // === PATCH 2 : window.scrollTo no-op pendant variant change ===
  // (Dawn utilise window.scrollTo({behavior:'smooth'}) dans setActiveMedia)
  var origWindowScrollTo = window.scrollTo.bind(window);
  window.scrollTo = function () {
    if (inVariantChange && !allowOurScroll) {
      return; // bloqué pendant variant change
    }
    return origWindowScrollTo.apply(window, arguments);
  };

  // Notre propre scroll-to-top, qui contourne le patch
  function ourScrollToTop() {
    allowOurScroll = true;
    try {
      origWindowScrollTo({ top: 0, left: 0, behavior: 'auto' });
    } finally {
      allowOurScroll = false;
    }
  }

  // === UTILITAIRES ===
  var COLOR_OPTION_NAMES = ['couleur', 'color', 'colour'];

  function normalize(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function isColorOption(text) {
    var t = normalize(text);
    return COLOR_OPTION_NAMES.some(function (name) { return t.indexOf(name) !== -1; });
  }

  function getSelectedColor(variantSelects) {
    if (!variantSelects) return null;

    var fieldsets = variantSelects.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (!legend) continue;
      if (isColorOption(legend.textContent.split(':')[0])) {
        var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
        if (checked) return checked.value;
        var span = legend.querySelector('[data-selected-value]');
        if (span && span.textContent) return span.textContent.trim();
      }
    }

    var dropdowns = variantSelects.querySelectorAll('.product-form__input--dropdown');
    for (var j = 0; j < dropdowns.length; j++) {
      var label = dropdowns[j].querySelector('label.form__label');
      if (!label) continue;
      if (isColorOption(label.textContent)) {
        var sel = dropdowns[j].querySelector('select');
        if (sel) return sel.value;
      }
    }

    var json = variantSelects.querySelector('script[data-selected-variant]');
    if (json) {
      try {
        var v = JSON.parse(json.textContent);
        if (v && v.option1) return v.option1;
      } catch (e) { /* ignore */ }
    }
    return null;
  }

  // === FILTRAGE GALERIE ===
  function filterGallery(gallery, colorName) {
    if (!gallery || !colorName) return;
    var target = normalize(colorName);

    var firstVisibleSlide = null;
    var visibleCount = 0;

    var slides = gallery.querySelectorAll('.product__media-item');
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      var alt = img ? normalize(img.alt) : '';
      if (alt.indexOf(target) !== -1) {
        slide.removeAttribute('hidden');
        slide.style.removeProperty('display');
        visibleCount++;
        if (!firstVisibleSlide) firstVisibleSlide = slide;
      } else {
        slide.setAttribute('hidden', '');
        slide.style.display = 'none';
      }
    });

    var thumbs = gallery.querySelectorAll('.thumbnail-list__item');
    thumbs.forEach(function (thumb) {
      var img = thumb.querySelector('img');
      var alt = img ? normalize(img.alt) : '';
      if (alt.indexOf(target) !== -1) {
        thumb.removeAttribute('hidden');
        thumb.style.removeProperty('display');
      } else {
        thumb.setAttribute('hidden', '');
        thumb.style.display = 'none';
      }
    });

    var counterTotal = gallery.querySelector('.slider-counter--total');
    if (counterTotal) counterTotal.textContent = visibleCount;
    var counterCurrent = gallery.querySelector('.slider-counter--current');
    if (counterCurrent) counterCurrent.textContent = visibleCount > 0 ? '1' : '0';

    if (firstVisibleSlide) {
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      firstVisibleSlide.classList.add('is-active');

      var mediaId = firstVisibleSlide.dataset.mediaId;
      thumbs.forEach(function (t) {
        var btn = t.querySelector('button');
        if (!btn) return;
        if (t.dataset.target === mediaId) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      });
    }
  }

  // === CACHE COULEUR : skip filter si même couleur ===
  var lastFilteredColor = {};

  function applyForSection(sectionId) {
    if (!sectionId) return false;
    var productInfo = document.querySelector('product-info[data-section="' + sectionId + '"]');
    if (!productInfo) return false;
    var variantSelects = productInfo.querySelector('variant-selects');
    var gallery = document.getElementById('MediaGallery-' + sectionId);
    if (!variantSelects || !gallery) return false;

    var color = getSelectedColor(variantSelects);
    if (!color) return false;

    var prev = lastFilteredColor[sectionId];
    if (prev === color) {
      return false; // taille seulement
    }

    filterGallery(gallery, color);
    lastFilteredColor[sectionId] = color;
    return prev !== undefined; // true seulement si pas l'init
  }

  function applyAll() {
    document.querySelectorAll('product-info[data-section]').forEach(function (pi) {
      applyForSection(pi.dataset.section);
    });
  }

  // === PRÉ-SÉLECTION VIA URL ===
  function getParamCaseInsensitive(params, name) {
    var lower = name.toLowerCase();
    var iter = params.keys();
    var keys = [];
    var k = iter.next();
    while (!k.done) { keys.push(k.value); k = iter.next(); }
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].toLowerCase() === lower) return params.get(keys[i]);
    }
    return null;
  }

  function applyUrlParams() {
    if (typeof URLSearchParams === 'undefined') return false;
    var params = new URLSearchParams(window.location.search);
    if (!params.toString()) return false;

    var changed = false;

    document.querySelectorAll('product-info').forEach(function (productInfo) {
      var variantSelects = productInfo.querySelector('variant-selects');
      if (!variantSelects) return;

      variantSelects.querySelectorAll('fieldset').forEach(function (fieldset) {
        var legend = fieldset.querySelector('legend');
        if (!legend) return;
        var optionName = legend.textContent.split(':')[0].trim();
        if (!optionName) return;
        var paramValue = getParamCaseInsensitive(params, optionName);
        if (!paramValue) return;

        var radios = fieldset.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === paramValue && !radios[i].checked) {
            markVariantChange();
            radios[i].click();
            changed = true;
            break;
          }
        }
      });

      variantSelects.querySelectorAll('.product-form__input--dropdown').forEach(function (dd) {
        var label = dd.querySelector('label.form__label');
        if (!label) return;
        var optionName = label.textContent.trim();
        var paramValue = getParamCaseInsensitive(params, optionName);
        if (!paramValue) return;
        var select = dd.querySelector('select');
        if (select && select.value !== paramValue) {
          markVariantChange();
          select.value = paramValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          changed = true;
        }
      });
    });

    return changed;
  }

  // === INIT ===
  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event && event.data && event.data.sectionId) {
          var colorChanged = applyForSection(event.data.sectionId);
          if (colorChanged) {
            ourScrollToTop();
          }
        }
      });
    }

    applyAll();
    applyUrlParams();

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (!t.matches('input[type="radio"], select')) return;
      var pi = t.closest('product-info[data-section]');
      if (!pi) return;
      markVariantChange();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();